import react from 'react';

const TablePlaceholder = ({title, text, icon, coin_style}) => {
    return (
    <>
            <div style={{display: "flex", alignItems:"center", flexDirection:"column", rowGap: "5px"}}>
                <div className={coin_style? coin_style + "-coin" : 'warning-coin'} style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <div><span class="material-icons" style={{fontSize:"32px"}}>{icon}</span></div>
                </div>
                <div>
                <span className='black bold' style={{fontSize: "22px"}}> {title} </span>
                </div>
                <div style={{width: "20%"}}>
                <p style={{textAlign: "center"}}> {text}</p>
                </div>
            </div>
        </>
    )
}

export default TablePlaceholder;